module.exports = __webpack_public_path__ + "img/17_23.6285d89d.png";